import useAuthSession from 'context/AuthContext';

const userRoleId = (): number => {
  const authSession = useAuthSession();
  if (!authSession.isActive) return 99;

  return authSession.sessionData!.projectRole;
};

export default userRoleId;
